import { withTranslation } from 'react-i18next';
import { t } from "../../hooks/useAppTranslation";
/* eslint-disable no-unused-expressions */
import React from "react";
import PropTypes from "prop-types";
import {Link} from "react-router-dom";
import Draggable from "react-draggable";
import FocusTrap from 'focus-trap-react';
import clsx from 'clsx';
import "./PopUp.scss";

class PopUp extends React.Component {
  constructor(props) {
    super(props);
    this.showPopup = this.showPopup.bind(this);
  }

  componentDidMount = () => {
    document.body.classList.add('body-scroll-blocked');
  };

  componentWillUnmount = () => {
    document.body.classList.remove('body-scroll-blocked');
  };

  showPopup = () => {
    const {
      className,
      customContent,
      children,
      handleClosePopup,
      scrolled,
      title,
      type,
      active
    } = this.props;

    const popupClassName = clsx([
      'popUp',
      className,
    ]);

    const popupContentClassName = clsx([
      'popUp__content-container',
      scrolled && 'popUp__content-scrolled',
    ]);

    let newPopup;
    let PopUpContent = (
      <FocusTrap active={active}>
        <div
          className={popupClassName}
          aria-labelledby='dialogTitleId'
          aria-describedby='popUpInnerContent'
          aria-modal="true"
          role="dialog"
          tabIndex="-1"
        >
          <div id='popUpHeader' className={type}>
            {!this.props.hideCloseButton && (
              <button
                className='popUp__close-btn'
                onClick={customContent ? handleClosePopup : this.handleClosePopUp}
                type='button'
                autoFocus
              >
                <span className='sr-only'>{t('g-close-dialog')}</span>
                <img aria-hidden={true} alt='' src={require("../../Pics/close-window.png")} draggable={false} />
                <div className='confirm-label'>{t('g-confirm')}</div>
              </button>
            )}
            <h3 id='dialogTitleId' className='white h4'>{title}</h3>
          </div>
          {customContent ? (
            <div id='popUpInnerContent' className={popupContentClassName}>
              <span className="sr-only" role="alert">{t('g-open-dialog')}: {title}</span>
              {children}
            </div>
          ) : (
              <div id='popUpInnerContent' className={popupContentClassName} role="alert">
                {type === "notify" || type === "error" || type === "custom"
                  ? this.displayPopUpNotification()
                  : null}
                {type === "cancel" ? this.displayPopUpCancel() : null}
                {type === "confirm" ? this.displayPopUpConfirmation() : null}
              </div>
          )}
        </div>
      </FocusTrap>
    );

    type === "custom"
      ? (newPopup = PopUpContent)
      : (newPopup = (
        customContent
          ? <>{PopUpContent }</>
          : <Draggable
              handle='.popUp'
              defaultPosition={{ x: 0, y: 0 }}
              position={null}
              grid={[25, 25]}
              scale={1}
              onStart={this.handleStart}
              onDrag={this.handleDrag}
              onStop={this.handleClose}
            >
            {PopUpContent}
          </Draggable>
      ));

    return newPopup;
  };

  displayPopUpNotification = () => {
    let notification;
    let classes =
      this.props.type === "error" ? "btn save-btn error" : "btn save-btn";
    notification = (
      <div id='popUpNotification'>
        <div className='new-line'>{this.props.notification}</div>
        {this.props.type !== "custom" ? (
          <div className='btn_group'>
            <button
              className={classes}
              onClick={
                this.props.onClickEvent
                  ? this.handleOnClick
                  : this.handleClosePopUp
              }
            >
              {t('g-ok')}
            </button>
          </div>
        ) : null}
      </div>
    );
    return notification;
  };

  displayPopUpCancel = () => {
    let cancelButton;
    cancelButton =
      this.props.link || this.props.link !== null ? (
        <Link to={this.props.link} className='btn save-btn uppercase'>
          {t("g-yes")}
        </Link>
      ) : (
        <button className='btn save-btn uppercase' onClick={this.handleOnClick}>
          {t("g-yes")}
        </button>
      );

    let cancel;
    cancel = (
      <div id='popUpNotification'>
        <div className='new-line'>{this.props.notification}</div>
        <div className='btn_group'>
          {cancelButton}
          <button
            className='btn cancel-btn uppercase'
            id='rejectStart'
            onClick={this.handleClosePopUp}
          >
            {t("g-no")}
          </button>
        </div>
      </div>
    );
    return cancel;
  };

  displayPopUpConfirmation = () => {
    let confirm;
    confirm = (
      <div id='popUpNotification'>
        <div className='new-line'>{this.props.notification}</div>
        <div className='btn_group'>
          <button className='btn save-btn uppercase' onClick={this.handleOnClick}>
            {this.props.confirmText || t("g-yes")}
          </button>
          &nbsp;
          <button className='btn cancel-btn uppercase' onClick={this.handleClosePopUp}>
            {this.props.cancelText || t("g-no")}
          </button>
        </div>
      </div>
    );
    return confirm;
  };

  handleOnClick = () => {
    if (this.props?.isAsync) {
      this.props.onClickEvent ? this.props.onClickEvent() : null;
      this.handleClosePopUp();
    } else {
      this.handleClosePopUp();
      this.props.onClickEvent ? this.props.onClickEvent() : null;
    }
  };

  handleClosePopUp = () => {
      this.props.closePopUp ? this.props.closePopUp() : null;
  };

  render() {
    return (
      <div className={`popUp-wrapper${this.props.highPriority ? ' popUp-wrapper--priority' : this.props.refreshTokenPopup ? ' popUp-wrapper--refresh-token' : ''}`}>
        {this.showPopup()}
      </div>
    );
  }
}

PopUp.defaultProps = {
  type: "notify",
  size: 1,
  active: true,
  isAsync: false
};

PopUp.propTypes = {
  title: PropTypes.string.isRequired,
  notification: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  type: PropTypes.oneOf(["notify", "cancel", "error", "confirm", "custom"]),
  link: PropTypes.string,
  size: PropTypes.oneOf([1, 2, 3]),
  onClickEvent: PropTypes.func,
  closePopUp: PropTypes.func,
  isAsync: PropTypes.bool,
};

export default withTranslation()(PopUp);